<template>
  <div class="order-line">
    <div class="line-header">
      <div class="order-number" v-if="hasSubOrder">
        系统订单编号: {{ orderInfo.orderNumber }}
      </div>
      <div class="order-number" v-else>
        <span>订单编号: {{ orderInfo.orderNumber }}</span>
        <span style="margin-left: 170px" v-if="orderInfo.tradeApplyNumber">trade订单编号：{{ orderInfo.tradeApplyNumber }}</span>
      </div>
      <div class="order-date">
        下单人：{{ orderInfo.createUserName }}
      </div>
      <div class="order-date">
        下单时间：{{ orderInfo.orderDate | parseTime }}
      </div>
      <div class="order-status" v-if="!hasSubOrder">状态：{{ orderInfo.orderStatusName }}</div>
      <div class="order-team-status" v-if="orderInfo.teamOrderStatusName&&!orderInfo.subOrderList">拼单状态：{{ orderInfo.teamOrderStatusName }}</div>
      <div class="order-poc" v-if="orderInfo.orderTypeName === 'shopSign'&&orderInfo.pocName">售点：{{ orderInfo.pocName }}</div>
      <div class="line-btn" style="right: 130px" v-if="!hasSubOrder & orderInfo.orderStatus === 50">
        <el-button class="btn-red-plain" size="small" @click="cancelOrder(orderInfo)">取消订单</el-button>
      </div>
      <div class="line-btn" v-if="!hasSubOrder">
        <el-button v-if="(orderInfo.orderStatus === 300 || orderInfo.orderStatus === 400) && !orderInfo.evaluateFlag && orderType === 'menu'" class="btn-red-plain" size="small" style="width: 80px" @click="toEvaluation(orderInfo)">评价</el-button>
        <!-- <el-button v-if="(orderInfo.orderStatus === 300 || orderInfo.orderStatus === 400) && orderInfo.evaluateFlag && orderType === 'menu'" class="btn-red-plain" size="small" style="width: 80px">已评价</el-button> -->
        <el-button class="btn-blue-plain" size="small" @click="viewOrder(orderInfo)">查看详情</el-button>
      </div>
    </div>

    <div class="line-body">
      <div v-if="hasSubOrder">
        <div v-for="(subOrder, index) in orderInfo.subOrderList" :key="subOrder.subOrderId" class="sub-order">
          <el-row class="sub-order-header">
            <el-col :span="7" class="sub-order-number">
              采购订单编号: {{ subOrder.orderNumber }}
            </el-col>
            <el-col :span="4" class="sub-order-status">
              状态: {{ subOrder.orderStatusName }}
            </el-col>
            <el-col :span="4" class="sub-order-team-status">
              <span  v-if="subOrder.teamOrderStatusName">
                拼单状态: {{ subOrder.teamOrderStatusName }}
              </span>
            </el-col>
            <el-col :span="9" class="sub-order-btns">
              <el-button v-if="subOrder.orderStatus === 50" class="btn-red-plain" size="small" @click="cancelOrder(subOrder)" style="margin-right: 5px">取消订单</el-button>
              <el-button v-if="(subOrder.orderStatus === 300 || subOrder.orderStatus === 400) && !subOrder.evaluateFlag && orderType === 'menu'" class="btn-red-plain" size="small" style="width: 80px" @click="toEvaluation(subOrder)">评价</el-button>
              <!-- <el-button v-if="(subOrder.orderStatus === 300 || subOrder.orderStatus === 400) && subOrder.evaluateFlag && orderType === 'menu'" class="btn-red-plain" size="small" style="width: 80px">已评价</el-button> -->
              <el-button class="btn-blue-plain" size="small" @click="viewOrder(subOrder)">查看详情</el-button>
            </el-col>
          </el-row>
          <OrderLineDetail :detail-list="subOrder.detailList" :order-info="orderInfo.subOrderList[index]"/>
        </div>
      </div>
      <div v-else>
        <OrderLineDetail :detail-list="orderInfo.detailList" :order-info="orderInfo"/>
      </div>
    </div>

  </div>
</template>

<script>
import OrderLineDetail from './order-line-detail'
export default {
  name: 'order-line',
  components: {
    OrderLineDetail
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    orderType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    hasSubOrder () {
      return this.orderInfo.subOrderList && this.orderInfo.subOrderList.length > 0
    }
  },
  methods: {
    viewOrder (subOrder) {
      let routeUrl = this.$router.resolve({
        path: '/order/info',
        query: {
          orderId: subOrder.orderId,
          orderType: subOrder.orderTypeName
        }
      })
      window.open(routeUrl.href, '_blank')
    },

    // 取消订单
    cancelOrder (order) {
      this.$confirm('是否确认取消订单', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('cancelOrder', order.orderId).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('订单关闭成功')
            this.$emit('reload')
          }
        })
      }).catch(() => {})
    },
    // 跳转评价页
    toEvaluation (subOrder) {
      localStorage.setItem('orderInfo', JSON.stringify(subOrder))
      this.$router.push({
        path: '/order/evaluation'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-line {
  background-color: $base-lightpink;
  border-radius: 10px;
  padding: 16px 0;
  margin-bottom: 20px;
  position: relative;

  .line-header {
    color: $base-red;
    padding: 0 20px 10px 20px;

    .order-number {
      font-weight: 700;
      line-height: 24px;
      font-size: 16px;
    }
    .order-date {
      font-size: 14px;
      line-height: 24px;
    }
    .line-btn {
      position: absolute;
      top: 35px;
      right: 36px;
    }
    .order-status {
      position: absolute;
      top: 45px;
      left: 355px;
    }
    .order-team-status{
      position: absolute;
      top: 45px;
      left: 600px;
    }
    .order-poc{
      position: absolute;
      top:70px;
      left:355px;
      width:300px;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }
  .line-body {
    background-color: $base-white;

    .sub-order {
      margin-bottom: 10px;

      .sub-order-header {
        padding: 15px;
        line-height: 32px;
        border-bottom: 1px solid $base-grey3;

        .sub-order-number {
          font-weight: 700;
        }
        .sub-order-team-status{
          padding-left:50px;
        }
        .sub-order-btns {
          text-align: right;
          padding-right: 20px;
        }
      }
    }
  }
}

</style>
